import type { Affiliate } from 'services/affiliates/types'
import style from './style.scss'

type Props = {
  result: Affiliate
}

function AffiliateItem(props: Props) {
  const { result } = props
  const { name, city, stateCode, countryShortCode } = result

  return (
    <li className={style.wrapper}>
      <strong className={style.title}>{name}</strong>
      <p>
        {city}, {stateCode} {countryShortCode}
      </p>
    </li>
  )
}

export default AffiliateItem
